export const PHONE_REGEXP = /(\+)\d+$/

export const phoneNumberValidator = (value) => !value || PHONE_REGEXP.test(value)
